import { multipleCallback } from '../util/multipleCallback';
export function callEffectForEach(effect) {
    return function (property) {
        var clear = effect(property.get());
        var unsubscribe = property.subscribe(function () {
            clear();
            clear = effect(property.get());
        });
        return multipleCallback([unsubscribe, clear]);
    };
}
//# sourceMappingURL=callEffectForEach.js.map